/**
 * ⚠️ HAND-WRITTEN FILE - DO NOT DELETE! ⚠️
 *
 * Brand icons for the Finder status bar and Connect folder.
 */

import type { ComponentType } from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { UnsplashIcon } from '@/components/icons/UnsplashIcon';
import { SpotifyIcon } from '@/components/icons/SpotifyIcon';
import { DiscordIcon } from '@/components/icons/DiscordIcon';
import { HackerNewsIcon } from '@/components/icons/HackerNewsIcon';
import { FiverrIcon } from '@/components/icons/FiverrIcon';
import type { SocialLinkId } from '@/lib/socialLinks';

const ICONS: Record<SocialLinkId, ComponentType<SvgIconProps>> = {
  ama: DiscordIcon,
  instagram: InstagramIcon,
  x: XIcon,
  github: GitHubIcon,
  linkedin: LinkedInIcon,
  unsplash: UnsplashIcon,
  spotify: SpotifyIcon,
  hn: HackerNewsIcon,
  fiverr: FiverrIcon,
  facebook: FacebookIcon,
};

export function HomeSocialIcon({ id, ...props }: { id: SocialLinkId } & SvgIconProps) {
  const Icon = ICONS[id];
  return <Icon fontSize="small" {...props} />;
}
